// extracted by mini-css-extract-plugin
module.exports = {"UiSkeleton":"skeleton_UiSkeleton__Vne_5","pulse":"skeleton_pulse__Cvzz0"};